export interface IFileItemConfigArgs {
    displayAs?: string;
    embedLink?: boolean;
    group?: string;
    description?: string;
    displayedName?: string;
    rotation?: number;
}

export class FileItemConfig {
    displayAs: string;
    embedLink: boolean;
    group: string;
    description: string;
    displayedName: string;
    rotation: number;

    static fromJson(json: string): FileItemConfig {
        return new FileItemConfig(JSON.parse(json));
    }

    constructor(
        {
            displayAs,
            embedLink,
            group,
            description,
            displayedName,
            rotation
        }: IFileItemConfigArgs = {}
    ) {
        this.displayAs = displayAs || 'grid';
        this.embedLink = embedLink || false;
        this.group = group || 'other';
        this.description = description || '';
        this.displayedName = displayedName || '';
        this.rotation = rotation || 0;
    }

    validateAndSetDisplayedName(name: string): void {
        const oldName = this.displayedName;
        try {
            this.displayedName = this.validateDisplayedName(name);
        } catch (e) {
            this.displayedName = oldName;
            throw(e);
        }
    }

    rotate(rotation: number = this.rotation): FileItemConfig {

        if (typeof rotation !== 'number') {
            throw Error('degrees is not instance of number');
        }

        let r = rotation;
        r %= 360;

        return new FileItemConfig({
            displayAs: this.displayAs,
            embedLink: this.embedLink,
            group: this.group,
            description: this.description,
            displayedName: this.displayedName,
            rotation: r
        });
    }

    protected validateDisplayedName(name: string): string {
        const rg1 = /^[^\\/:\*\?"<>\|]+$/; // forbidden characters \ / : * ? " < > |
        const rg2 = /^\./; // cannot start with dot (.)
        const rg3 = /^(nul|prn|con|lpt[0-9]|com[0-9])(\.|$)/i;
        if (!name) {
            throw({
                message: 'Please add a file name',
                given: name,
                min: 1,
                max: 255
            });
        } else if (!rg1.test(name) || rg2.test(name) || rg3.test(name)) {
            throw({
                message: 'Invalid characters in file name',
                given: name,
                min: 1,
                max: 255
            });
        }
        return name;
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/file/file-config.model.ts